import { WORKFLOW_WEBHOOK_CURRENT_VERSION } from "@babackapp/tracking-status-registry";
import { Webhook } from "lucide-react";
import { NodeCategory, registerNode } from "../../lib/register-node";
import { WebhookActionNodeEditor } from "./editor";
import { WebhookActionNodePanel } from "./panel";

const newNodeDefaultValue: any = {
  actionType: "send_webhook",
  // Pinned at creation: the node keeps this payload format after a new one ships.
  config: { url: "", version: WORKFLOW_WEBHOOK_CURRENT_VERSION },
};

export default registerNode<any["data"]>({
  type: "action:send_webhook",
  name: "workflowsEditor.nodes.sendWebhook.title",
  description: "workflowsEditor.nodes.sendWebhook.description",
  Icon: Webhook,
  category: NodeCategory.ACTION,
  color: "blue",
  editor: {
    component: WebhookActionNodeEditor,
  },
  configPanel: {
    component: WebhookActionNodePanel,
  },
  newNodeDefaultData: newNodeDefaultValue,
});

export { WebhookActionNodeEditor } from "./editor";
export { WebhookActionNodePanel } from "./panel";
